import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getLoginDetailFromSession } from '../../helpers/sessionDetails';
import UI from '../../constants/ui';
import URL from '../../constants/urls';
import LOGIN_TYPE from '../../constants/loginType';
import styles from './navigationComponent.module.css';
import ServicesMenu from './ServiceLink';

function RenderNavBarButtons(props) {
  const { loggedInUserRole, activeUrl } = props;

  if (loggedInUserRole === LOGIN_TYPE.EMPLOYER) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <Link
            to={URL.FIND_CANDIDATES}
            className={`color-1F2830 ${styles.navLink} ${
              activeUrl === URL.FIND_CANDIDATES
                ? `subtitle-1-bold`
                : 'subtitle-1'
            }`}
            style={{
              display: 'inline-block',
              textDecoration: 'none',
              paddingBottom: '4px',
            }}
          >
            {UI.FIND_TALENT}
          </Link>

          {activeUrl === URL.FIND_CANDIDATES && (
            <div
              className={`background-1D8FF2 ${styles.active}`}
              style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                height: '2px',
                width: '100%',
                backgroundColor: '#1D8FF2',
              }}
            />
          )}
        </div>
        <ServicesMenu role={loggedInUserRole} />
      </div>
    );
  }
  if (loggedInUserRole === LOGIN_TYPE.CANDIDATE) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <Link
            to={URL.FIND_JOBS}
            className={`color-1F2830 ${styles.navLink} ${
              activeUrl === URL.FIND_JOBS ? `subtitle-1-bold` : 'subtitle-1'
            }`}
            style={{
              display: 'inline-block',
              textDecoration: 'none',
              paddingBottom: '4px',
            }}
          >
            {UI.FIND_JOBS}
          </Link>

          {activeUrl === URL.FIND_JOBS && (
            <div
              className={`background-1D8FF2 ${styles.active}`}
              style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                height: '2px',
                width: '100%',
                backgroundColor: '#1D8FF2',
              }}
            />
          )}
        </div>
        <ServicesMenu role={loggedInUserRole} />
      </div>
    );
  }
  if (loggedInUserRole === LOGIN_TYPE.UNIVERSITY) {
    return (
      <div className="d-flex justify-content-center col-4 ">
        <div className={`color-1F2830 univ-headline span-together px-4 py-1 `}>
          {getLoginDetailFromSession()?.name}
        </div>
      </div>
    );
  }
  if (loggedInUserRole === LOGIN_TYPE.ADMIN) {
    return (
      <>
        <div className="me-3">
          <Link
            to={`${URL.ADMIN_ACTION}?action=site_map`}
            className={`color-1F2830 ${styles.navLink}  ${
              activeUrl === URL.ADMIN_ACTION
                ? `subtitle-1-bold ${styles.active}`
                : 'subtitle-1'
            }`}
          >
            {UI.ACTIONS}
          </Link>
          {activeUrl === URL.ADMIN_ACTION && (
            <div className={`background-1D8FF2 ${styles.active}`} />
          )}
        </div>
        <div className="ms-3">
          <Link
            to={URL.ADMIN_ANALYTICS}
            className={`color-1F2830 ${styles.navLink} ${
              activeUrl === URL.ADMIN_ANALYTICS
                ? `subtitle-1-bold ${styles.active}`
                : 'subtitle-1'
            }`}
          >
            {UI.ANALYTICS}
          </Link>
          {activeUrl === URL.ADMIN_ANALYTICS && (
            <div className={`background-1D8FF2 ${styles.active}`} />
          )}
        </div>
        <div className="ms-3">
          <Link
            to={URL.ADMIN_WHATSAPP}
            className={`color-1F2830 ${styles.navLink} ${
              activeUrl === URL.ADMIN_WHATSAPP
                ? `subtitle-1-bold ${styles.active}`
                : 'subtitle-1'
            }`}
          >
            {UI.WHATSAPP}
          </Link>
          {activeUrl === URL.ADMIN_WHATSAPP && (
            <div className={`background-1D8FF2 ${styles.active}`} />
          )}
        </div>
      </>
    );
  }
  return null;
}

RenderNavBarButtons.propTypes = {
  loggedInUserRole: PropTypes.number,
  activeUrl: PropTypes.string,
};

RenderNavBarButtons.defaultProps = {
  loggedInUserRole: undefined,
  activeUrl: '',
};

export default RenderNavBarButtons;
